import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInSeconds,
  format,
  isSameDay,
  isSameYear,
} from 'date-fns';

export interface AgoOptions {
  lowerCase?: boolean;
  now?: number | string | Date;
  alwaysShowYear?: boolean;
}

export function ago(
  timestamp: number | string | Date,
  options?: AgoOptions
): string {
  const now = options?.now ?? Date.now();

  const secondsDiff = differenceInSeconds(now, timestamp);

  if (secondsDiff < 0) {
    return inFuture(timestamp, options);
  } else if (secondsDiff < 60) {
    return options?.lowerCase ? 'just now' : 'Just now';
  } else if (differenceInMinutes(now, timestamp) < 60) {
    return `${differenceInMinutes(now, timestamp)}m ago`;
  } else if (differenceInHours(now, timestamp) < 24) {
    return `${differenceInHours(now, timestamp)}h ago`;
  } else if (isSameYear(now, timestamp) && !options?.alwaysShowYear) {
    return format(timestamp, 'MMM d');
  } else {
    return format(timestamp, 'MMM d, yyyy');
  }
}

export function inFuture(
  timestamp: number | string | Date,
  options?: AgoOptions
): string {
  const now = options?.now ?? Date.now();

  if (isSameDay(now, timestamp)) {
    if (differenceInSeconds(now, timestamp) >= 0) {
      return ago(timestamp, options);
    } else if (differenceInMinutes(now, timestamp) > -60) {
      return `in ${differenceInMinutes(timestamp, now)}m`;
    } else {
      return `in ${differenceInHours(timestamp, now)}h`;
    }
  }

  const daysDiff = differenceInDays(timestamp, now);
  if (daysDiff <= 1) {
    return `tomorrow`;
  } else if (isSameYear(now, timestamp) && !options?.alwaysShowYear) {
    return `on ${format(timestamp, 'MMM d')}`;
  } else {
    return `on ${format(timestamp, 'MMM d, yyyy')}`;
  }
}

export function isCurrentYear(timestamp: Date | string | number) {
  return isSameYear(timestamp, new Date());
}
